import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageRouteHandler = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  // Use useLayoutEffect to run BEFORE paint/render
  useLayoutEffect(() => {
    const path = location.pathname;
    let lang = 'et'; // default - Estonian as the primary language

    if (path.startsWith('/en')) {
      lang = 'en';
    } else if (path.startsWith('/ru')) {
      lang = 'ru';
    } else if (path.startsWith('/ar')) {
      lang = 'ar';
    }

    // Change language SYNCHRONOUSLY before render
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }
  }, [location.pathname, i18n]);

  return children;
};

export default LanguageRouteHandler;
